module.exports = __webpack_public_path__ + "img/hospital-angeles.d5e12bd0.jpg";